module.exports = "uniform vec2 uvRate1;\nuniform vec2 uvRate2;\n\nvarying vec2 vUv1;\nvarying vec2 vUv2;\n\n\nvoid main() {\n    vec2 _uv = uv - 0.5;\n    vUv1 = _uv;\n    vUv1 *= uvRate1.xy;\n    vUv1 += 0.5;\n\n    vUv2 = _uv;\n    vUv2 *= uvRate2.xy;\n    vUv2 += 0.5;\n  gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}\n"


//////////////////
// WEBPACK FOOTER
// ./scripts/elements/HoverDistortion/vertex.glsl
// module id = 224
// module chunks = 0